export function formatCurrency(cents: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(cents / 100);
}

export function formatHours(hours: number): string {
  return `${hours.toFixed(2)}h`;
}

export function isFeatureEnabled(
  flag: string,
  envValue: string | boolean | undefined,
): boolean {
  if (typeof envValue === "boolean") return envValue;
  if (typeof envValue === "string") {
    return envValue === "true" || envValue === "1";
  }
  return false;
}

export function buildApiUrl(baseUrl: string, path: string): string {
  const normalizedBase = baseUrl.replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}
